import { allowSeedContent } from '../../lib/runtime'

/** Saved dish photos remain explicit. Stock substitutions are limited to demo mode. */

const SEED = (path: string) => `/seed/${path}.webp`

/** Category → local food photo. Categories mirror dish.category values. */
const CATEGORY_IMAGE: Record<string, string> = {
  rice: SEED('dish/jollof'),
  soups: SEED('dish/egusi'),
  soup: SEED('dish/egusi'),
  main: SEED('dish/jollof'),
  mains: SEED('dish/jollof'),
  protein: SEED('dish/suya'),
  meat: SEED('dish/suya'),
  chicken: SEED('dish/jollof'),
  fish: SEED('dish/suya'),
  grill: SEED('dish/suya'),
  breakfast: SEED('dish/jollof'),
  chops: SEED('dish/suya'),
  small_chops: SEED('dish/suya'),
  snacks: SEED('dish/suya'),
  snack: SEED('dish/suya'),
  puff: SEED('dish/jollof'),
  puffs: SEED('dish/jollof'),
  pastry: SEED('dish/jollof'),
  pastries: SEED('dish/jollof'),
  bakery: SEED('dish/jollof'),
  dessert: SEED('dish/jollof'),
  desserts: SEED('dish/jollof'),
  cake: SEED('dish/jollof'),
  drinks: SEED('dish/drinks'),
  drink: SEED('dish/drinks'),
  beverage: SEED('dish/drinks'),
  beverages: SEED('dish/drinks'),
  zobo: SEED('dish/drinks'),
  chapman: SEED('dish/drinks'),
  salad: SEED('dish/jollof'),
  salads: SEED('dish/jollof'),
  sides: SEED('dish/akara'),
  side: SEED('dish/akara'),
  swallow: SEED('dish/egusi'),
  swallows: SEED('dish/egusi'),
  traditional: SEED('dish/jollof'),
}

/** A local default when the category is unknown. */
const DEFAULT_IMAGE = SEED('dish/jollof')

/**
 * Curated stock photo for a dish *category* or dish *name*.
 */
export const categoryImage = (category?: string, name?: string): string | undefined => {
  const catKey = String(category ?? '').trim().toLowerCase()
  if (catKey && CATEGORY_IMAGE[catKey]) {
    return CATEGORY_IMAGE[catKey]
  }
  const nameKey = String(name ?? '').trim().toLowerCase()
  if (nameKey) {
    for (const [key, url] of Object.entries(CATEGORY_IMAGE)) {
      if (nameKey.includes(key)) return url
    }
  }
  if (catKey) return DEFAULT_IMAGE
  return undefined
}

/** Seed assets that still are synthetic placeholder cards rather than photos. */
const SYNTHETIC_SEED_ASSETS = [
  '/seed/dish/akara.png',
  '/seed/dish/akara.webp',
  '/seed/dish/cake.png',
  '/seed/dish/cake.webp',
  '/seed/dish/ofada.png',
  '/seed/dish/ofada.webp',
  '/seed/dish/pastry.png',
  '/seed/dish/pastry.webp',
  '/seed/dish/tilapia.png',
  '/seed/dish/tilapia.webp',
  '/seed/menu/amara-weekly.png',
  '/seed/menu/amara-weekly.webp',
  '/seed/menu/laila-sweet.png',
  '/seed/menu/laila-sweet.webp',
  '/seed/menu/tunde-reset.png',
  '/seed/menu/tunde-reset.webp',
]

export const isLegacyStockImage = (src?: string): boolean => {
  if (!src) return false
  return /images\.unsplash\.com|images\.pexels\.com|source\.unsplash\.com/i.test(src)
}

export const chefPhoto = (src?: string, _cuisine?: string, _name?: string): string | undefined => {
  const trimmed = String(src ?? '').trim()
  return trimmed && !isSyntheticSeedAsset(trimmed) ? trimmed : undefined
}

export const dishPhoto = (src?: string, category?: string, name?: string): string | undefined => {
  const trimmed = String(src ?? '').trim()
  if (trimmed && !isSyntheticSeedAsset(trimmed) && !isLegacyStockImage(trimmed)) return trimmed
  return allowSeedContent() ? categoryImage(category, name) : undefined
}

/** Whether a stored image path is a generated placeholder rather than a photo. */
export const isSyntheticSeedAsset = (src?: string): boolean => {
  if (!src) return false
  if (SYNTHETIC_SEED_ASSETS.some((asset) => src.includes(asset))) return true
  return false
}
